import { Well } from '#models';

const wells: Well[] = [
  {
    id: 1,
    wellName: 'HAYDEN 08-05 51TB',
    wellViewName: 'HAY DENISE STATE 08/05 0051TB',
    api10: '4210933560',
    api14: '42109335600001',
    state: 'TEXAS',
    fot: 'HAYHURST TX',
    area: 'HAYHURST TX',
    sectionName: 'HHTX S17 EVELYN CTB',
    gaugerBeatName: 'HAYHURST TX',
    archived: false,
    wellTest1: 230.99,
    wellTest2: 226.16,
    wellTest3: 201.36,
    wellTestAvg: 219.5,
  },
  {
    id: 2,
    wellName: 'HAYDEN 08-05 21TB',
    wellViewName: 'HAY DENISE STATE 08/05 0021TB',
    api10: '4210933605',
    api14: '42109336050001',
    state: 'TEXAS',
    fot: 'HAYHURST TX',
    area: 'HAYHURST TX',
    sectionName: 'HHTX S17 EVELYN CTB',
    gaugerBeatName: 'HAYHURST TX',
    archived: false,
    wellTest1: 180.5,
    wellTest2: 175.2,
    wellTest3: 170.1,
    wellTestAvg: 175.3,
  },
  {
    id: 3,
    wellName: 'HAYDEN 08-05 22WA',
    wellViewName: 'HAY DENISE STATE 08/05 0022WA',
    api10: '4210933607',
    api14: '42109336070001',
    state: 'TEXAS',
    fot: 'HAYHURST TX',
    area: 'HAYHURST TX',
    sectionName: 'HHTX S17 EVELYN CTB',
    gaugerBeatName: 'HAYHURST TX',
    archived: false,
    wellTest1: 195.0,
    wellTest2: 188.5,
    wellTest3: 192.0,
    wellTestAvg: 191.8,
  },
  {
    id: 4,
    wellName: 'HAYDEN 08-05 23TB',
    wellViewName: 'HAY DENISE STATE 08/05 0023TB',
    api10: '4210933606',
    api14: '42109336060001',
    state: 'TEXAS',
    fot: 'HAYHURST TX',
    area: 'HAYHURST TX',
    sectionName: 'HHTX S17 EVELYN CTB',
    gaugerBeatName: 'HAYHURST TX',
    archived: false,
    wellTest1: 210.0,
    wellTest2: 205.5,
    wellTest3: 200.0,
    wellTestAvg: 205.2,
  },
  {
    id: 5,
    wellName: 'HAYDEN 08-05 24WA',
    wellViewName: 'HAY DENISE STATE 08/05 0024WA',
    api10: '4210933608',
    api14: '42109336080001',
    state: 'TEXAS',
    fot: 'HAYHURST TX',
    area: 'HAYHURST TX',
    sectionName: 'HHTX S17 EVELYN CTB',
    gaugerBeatName: 'HAYHURST TX',
    archived: false,
    wellTest1: 165.0,
    wellTest2: 160.3,
    wellTest3: 158.7,
    wellTestAvg: 161.3,
  },
  {
    id: 6,
    wellName: 'HAYDEN 08-05 25WA',
    wellViewName: 'HAY DENISE STATE 08/05 0025WA',
    api10: '4210933609',
    api14: '42109336090001',
    state: 'TEXAS',
    fot: 'HAYHURST TX',
    area: 'HAYHURST TX',
    sectionName: 'HHTX S17 EVELYN CTB',
    gaugerBeatName: 'HAYHURST TX',
    archived: false,
    wellTest1: 188.0,
    wellTest2: 182.5,
    wellTest3: 179.1,
    wellTestAvg: 183.2,
  },
  {
    id: 7,
    wellName: 'COX 35 FEDERAL 2H',
    wellViewName: 'COX 35 FEDERAL STATE 2H',
    api10: '3002541521',
    api14: '30025415210001',
    state: 'NEW MEXICO',
    fot: 'HOBBS BASE',
    area: 'HOBBS BASE',
    sectionName: 'NM LEA COX 35 CTB',
    gaugerBeatName: 'HOBBS BASE',
    archived: false,
    wellTest1: 320.0,
    wellTest2: 315.5,
    wellTest3: 310.2,
    wellTestAvg: 315.2,
  },
  {
    id: 8,
    wellName: 'ABWJR-A-14',
    wellViewName: 'ABWJR UNIT A WELL 14',
    api10: '4216536276',
    api14: '42165362760001',
    state: 'TEXAS',
    fot: 'WHARTON',
    area: 'WHARTON',
    sectionName: 'TX WHARTON ABWJR CTB',
    gaugerBeatName: 'WHARTON',
    archived: false,
    wellTest1: 85.0,
    wellTest2: 82.3,
    wellTest3: 78.9,
    wellTestAvg: 82.1,
  },
  {
    id: 9,
    wellName: 'ADDISON #2',
    wellViewName: 'ADDISON UNIT WELL 2',
    api10: '4246134751',
    api14: '42461347510001',
    state: 'TEXAS',
    fot: 'QAFOT',
    area: 'DAWSON TX',
    sectionName: 'TX DAWSON ADDISON CTB',
    gaugerBeatName: 'DAWSON TX',
    archived: false,
    wellTest1: 145.0,
    wellTest2: 140.2,
    wellTest3: 138.7,
    wellTestAvg: 141.3,
  },
  {
    id: 10,
    wellName: 'MID AX 14HB',
    wellViewName: 'MIDLAND AXLE STATE 14HB',
    api10: '4213500140',
    api14: '42135001400001',
    state: 'TEXAS',
    fot: 'ODESSA EAST',
    area: 'ODESSA EAST',
    sectionName: 'TX MIDLAND 14HB CTB',
    gaugerBeatName: 'ODESSA EAST',
    archived: false,
    wellTest1: 510.0,
    wellTest2: 505.5,
    wellTest3: 498.0,
    wellTestAvg: 504.5,
  },
  {
    id: 11,
    wellName: 'ANADRKO F 2',
    wellViewName: 'ANADARKO FEDERAL UNIT 2',
    api10: '3001532852',
    api14: '30015328520001',
    state: 'NEW MEXICO',
    fot: 'HOBBS BASE',
    area: 'HOBBS BASE',
    sectionName: 'NM LEA ANADRKO CTB',
    gaugerBeatName: 'HOBBS BASE',
    archived: false,
    wellTest1: 215.0,
    wellTest2: 210.3,
    wellTest3: 208.1,
    wellTestAvg: 211.1,
  },
  {
    id: 12,
    wellName: 'Hayden Demo',
    wellViewName: 'HAYDEN DEMO STATE',
    api10: '1234567860',
    api14: '12345678605555',
    state: 'TEXAS',
    fot: 'PECOS WEST',
    area: 'PECOS WEST',
    sectionName: 'TX PECOS HAYDEN CTB',
    gaugerBeatName: 'PECOS WEST',
    archived: false,
    wellTest1: 95.0,
    wellTest2: 92.5,
    wellTest3: 90.1,
    wellTestAvg: 92.5,
  },
];

export default wells;
